module.exports = __webpack_public_path__ + "static/media/selfie.3cc827e4.svg";